export default {
  GRAVATAR_URL: 'https://www.gravatar.com/avatar/',
  ASSIGNEE_TYPE: {
    ME: 'me',
    UNASSIGNED: 'unassigned',
    ALL: 'all',
  },
  STATUS_TYPE: {
    OPEN: 'open',
    RESOLVED: 'resolved',
    PENDING: 'pending',
    SNOOZED: 'snoozed',
    ALL: 'all',
  },
  SORT_BY_TYPE: {
    LATEST: 'latest',
    CREATED_AT: 'sort_on_created_at',
    PRIORITY: 'sort_on_priority',
  },
  ORDER_TYPE: {
    ASCENDING: 'asc',
    DESCENDING: 'desc',
  },
  ARTICLE_STATUS_TYPES: {
    DRAFT: 0,
    PUBLISH: 1,
    ARCHIVE: 2,
  },
  LAYOUT_TYPES: {
    CONDENSED: 'condensed',
    EXPANDED: 'expanded',
  },
  SERVICES_PRIVATE_URL: {
    BILLING: 'http://titan-billing:4242',
    BOT: window.hooryConfig?.botServiceUrl,
  },
  SERVICES_PATH: {
    BILLING: 'svc/billing',
    BOT: 'svc/bot',
    NOTEA: 'svc/notea',
    TYPEBOT_BUILDER: 'svc/typebot-builder',
    WEB_SIDECAR: 'svc/web-sidecar',
    CALL: 'svc/call',
  },
  DOCS_URL: 'https//www.hoory.com/docs/product/',
  TESTIMONIAL_URL: 'https://testimonials.cdn.hoory.com/content.json',
  SMALL_SCREEN_BREAKPOINT: 1024,
  AVAILABILITY_STATUS_KEYS: ['online', 'busy', 'offline'],
  SLA_MISS_TYPES: {
    FRT: 'frt',
    NRT: 'nrt',
    RT: 'rt',
  },
};
export const DEFAULT_REDIRECT_URL = '/app/';
